<template>
  <div class="view-works-wrapper">
    
    <div class="content-wrapper">
      <div class="view-list" v-for="(maker,idx) in makers" :key="idx">
        <h1><strong>{{maker.m_name}}</strong>  <button class="backToList" @click="backToList">Back</button>
        <button class="openEdit addToList" @click="openDetail(maker)">Add</button></h1> 
        <hr>
          <div class="clientTable" v-for="(sec, idx) in section" :key="idx">
            <h4>Section: {{sec.ms_name}}</h4>
            <div class="table">
              <div class="table-content">
                <div class="t-row">
                  <th>Type</th>
                  <th>Thumbnail Link</th>
                  <th>Content IMG Link</th>
                  <th></th>
                  <th></th>
                </div>
                <draggable v-model="works" :move="checkMove" @start="dragging=true" @end="updateSort">
                  <transition-group name="list-complete">
                    <div style="display: table-row;" class="drag t-row" v-for="work in works" :key="work.mw_sort" v-if="work.ms_id == sec.ms_id">
                      <td>{{work.mw_type}}</td>
                      <td>{{work.mw_thumb}}</td>
                      <td>{{work.mw_src}}</td>
                      <td><button @click="openEditWork(work)">Edit</button></td>
                      <td><button @click="deleteWork(work)">Del</button></td>
                      {{work.mw_sort}}
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </div>
          </div>
        </div>
        <DetailForm :select_maker="select_maker" />
      
      <!-- ##################################################################################################-->
      <div class="edit-work-wrapper">
        <div class="work-content">
          <h1>Edit Work Data</h1>
          <div class="input-row">     
            <label>Type</label>
            <input v-model="mw_type">
          </div>

          <div class="input-row">  
              <label>Thumbnail URL</label>
              <textarea v-model="mw_thumb" rows="2" cols="40" type="text" >
              </textarea>
          </div>

          <div class="input-row">     
            <label>Content IMG URL</label>
            <textarea v-model="mw_src" rows="2" cols="40" type="text" >
            </textarea>
          </div>

          <div class="input-row">     
            <label>Sort</label>
            <input v-model="mw_sort" type="text" >
          </div>
          
          <button type="submit" @click="editWork">Submit</button>
          <button type="submit" @click="closeWork" class="closeWork">Close</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import DetailForm from './DetailForm'
import draggable from 'vuedraggable'

export default {
  components: {
    DetailForm,
    draggable
  },
  created () { 
    
  },
  props: [
    'select_maker'
  ],
  data() {
    return {
      m_id: '',
      ms_id: '',
      mw_id: '',
      mw_type: '',
      mw_thumb: '',
      mw_src: '',   
      mw_sort: '',
      works: [],
      makers: [],
      section: [],
      worksss: [],
      all_works: [],
      select_makers: [],
    }
  },
  mounted() {
    this.getSingleWork()
  },
  methods: {
    openDetail(maker) {
      this.select_makers = maker
      this.m_id = maker.m_id
      var modal = document.querySelector('.detail-input-wrapper')
      modal.style.display = "block" 
    },
    getMaker() {
      axios.get('/api/makers/' + this.m_id)
        .then((response) => {
          this.makers = response.data
        })
    },
    getSection() {
      axios.get('/api/maker_section/' + this.m_id)
        .then((response) => {
          this.section = response.data
        })
    },
    getALlWork() {
      axios.get('/api/maker_works')
        .then((response) => {
          this.all_works = response.data
        })
    },
    getWork() {
      axios.get('/api/maker_works/' + this.m_id)
        .then((response) => {
          this.works = response.data
        })
    },
    getSingleWork() {
      axios.get('/api/maker_works/works/' + this.mw_id)
        .then((response) => {
          this.worksss = response.data
        })
    },
    backToList() {
      var modal = document.querySelector('.view-works-wrapper')
      modal.style.display = "none" 
    },
    openEditWork(work) {
      var modal = document.querySelector('.edit-work-wrapper')
      modal.style.display = "block"

      this.mw_id = work.mw_id
      this.mw_type = work.mw_type
      this.mw_thumb = work.mw_thumb
      this.mw_src = work.mw_src
      this.mw_sort = work.mw_sort
    },
    closeWork() {
      var modal = document.querySelector('.edit-work-wrapper')
      modal.style.display = "none"
    },
    editWork() {
      if(!this.mw_type || !this.mw_thumb || !this.mw_src || !this.mw_sort) {
        alert('Please check required fields.');
        return;
      }
      axios.put('/api/maker_works/works/'+ this.mw_id, {
        mw_type   : this.mw_type,
        mw_thumb   : this.mw_thumb,
        mw_src    : this.mw_src,
        mw_sort    : this.mw_sort

      }).then((response) => {
        this.getWork()
        if(response.data.affectedRows == 1) {
          this.getWork()
        }
      }).catch(e => {
        console.log(e)
      })
      var modal = document.querySelector('.edit-work-wrapper')
      modal.style.display = "none"
    },
    deleteWork(work) {
      console.log(work);
      
      axios.delete('/api/maker_works/works/' + work.mw_id)
        .then((response) => {
          if(response.data.code) {
            console.log(response.data.sqlMessage)
          }else if(response.data.affectedRows == 1) {
            this.getWork()  
          }
        }).catch(e => {
          console.log(e)
        })
        var modal = document.querySelector('.view-works-wrapper')
        modal.style.display = "none"
    },
    checkMove(e) {
      console.log("Index change to: " + e.draggedContext.futureIndex);
    },
    updateSort() {
      this.works.map((work, index) => {
        work.mw_sort = index + 1
      })

      axios.put('/api/maker_works/updateSort', {
        works: this.works
      }).then((response) => {
        this.getWork()
        console.log(response)
      })
    }
  },

  watch: {
    select_maker(arr) {
      this.m_id = arr.m_id
      this.getSection()
      this.getMaker()
      this.getWork()
    }
  }
}
</script>
<style lang="scss" scoped>
  .view-works-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    width: 100%; 
    height: 100%; 
    overflow: scroll;
    margin: 40px auto 0;
    padding: 20px;
    background-color: rgba(0,0,0,.5);
    z-index: 0;
    .content-wrapper {
      background-color: #fefefe;
      margin: auto;
      padding: 50px;
      border: 1px solid #888;
      width: 78%;
      overflow: auto;
      .view-list {
        .backToList {
          background: none;
          border: none;
          font-size: 30px;
          text-decoration: underline;
          float: right;
          cursor: pointer;
        }
        .addToList {
          background: none;
          border: none;
          font-size: 30px;
          text-decoration: underline;
          float: right;
          cursor: pointer;
          margin-right: 25px;
        }
        hr {
          border-top: 2px solid rgba(0,0,0,0.2);
        }
        .clientTable { 
          h4 {
            margin: 20px 0;
          }
          .table {
            margin: 0 auto 80px;
            font-family: arial, sans-serif;
            width: 100%;
            word-wrap: break-word;
            // table-layout: fixed;
            // display: table;
            .table-content {
              margin: 0 auto;
              .t-row {
                &.drag {
                  cursor: -moz-grab;
                  cursor: -webkit-grab;
                  cursor: grab;
                  transition: transform 0.25s cubic-bezier(0.02, 1.01, 0.94, 1.01);
                  will-change: transform;
                  
                  &:hover {
                    transition: transform 0.25s cubic-bezier(0.02, 1.01, 0.94, 1.01);
                    will-change: transform;
                    transform: scale(1.01);
                  }
                }
                td, th {
                  border: 1px solid rgba(0,0,0,.1);
                  padding: 9px; 
                  font-size: 13px;
                  max-width: 425px;

                  &:first-child {
                    min-width: 60px;
                  }
                  &:nth-child(2) {
                    min-width: 425px;
                  }
                  &:nth-child(3) {
                    min-width: 425px;
                  }
                  &:nth-child(4) {
                    min-width: 60px;
                  }
                  &:last-child {
                    min-width: 60px;
                  }
                  button {
                    background-color: #dae8ec;
                    border-radius: 5px;
                  }       
                }
              }
            }
          }
        }
      }
    }
    .edit-work-wrapper {
        display: none;
        position: fixed;
        background-color: #eeeeee;
        padding-top: 70px;
        top: 0;
        left: 0;
        width: 100%; 
        height: 100%; 
        overflow: auto;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,.5); 
        z-index: 99;
        .work-content {
          background-color: #fefefe;
          margin: auto;
          padding: 50px 50px 80px 50px;
          border: 1px solid #888;
          width: 35%;
        }
        .input-row {
          margin-bottom: 25px;
          input, textarea {
            width: 100%;
            font-size: 13px;
            padding: 3px;
          }
          textarea{
            border-color:rgb(186,186,186);
          }
        }   
        button {
          margin-top: 10px;
          margin-left: 15px;
          background: none;
          border-radius: 5%;
          padding: 5px 15px;
          width: 100px;
          float: right;
        }
        .closeWork {
          color: #fff;
          background-color: #eb8b57;

        }
      }
  }
</style>


// WEBPACK FOOTER //
// src/pages/ViewDetails.vue